// src/data/pharmacistMockData.js

export const prescriptionTrendsData = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
    {
      label: 'Mental Health',
      data: [12, 19, 3, 5, 2, 3, 7],
      borderColor: '#3f51b5',
      backgroundColor: 'rgba(63, 81, 181, 0.2)',
    },
    {
      label: 'Pain Relievers',
      data: [8, 11, 5, 6, 7, 9, 8],
      borderColor: '#f50057',
      backgroundColor: 'rgba(245, 0, 87, 0.2)',
    },
  ],
};

export const inventoryTurnoverData = {
  labels: ['Sertraline', 'Ibuprofen', 'Fluoxetine', 'Paracetamol', 'Lorazepam'],
  datasets: [
    {
      label: 'Units Sold',
      data: [150, 200, 175, 90, 120],
      backgroundColor: '#3f51b5',
    },
    {
      label: 'Units Restocked',
      data: [120, 180, 150, 110, 100],
      backgroundColor: '#f50057',
    },
  ],
};

export const financialReportsData = [
  {
    title: 'Total Revenue',
    value: '₹5,50,000',
    description: 'Revenue from filled prescriptions this quarter',
  },
  {
    title: 'Restocking Costs',
    value: '₹1,20,000',
    description: 'Costs associated with restocking medications',
  },
  {
    title: 'Net Profit',
    value: '₹4,30,000',
    description: 'Revenue minus restocking costs',
  },
];
